<ag-grid-angular
  dataSelector="email-delivery-hub-failed-table"
  class="ag-theme-material flex-fill-container-y"
  [columnDefs]="columnDefs()"
  [gridOptions]="gridOptions"
/>

<ng-template #actionsTemplate let-row>
  <div class="w-100 d-flex justify-content-center">
    @if (isDismissed(row.data.status)) {
      <div
        tooltip="You do not have permissions to restore emails."
        [tooltipEnabled]="!canResendEmails()"
      >
        <button
          dataSelector="email-delivery-hub-failed-undismiss-button"
          type="button"
          [disabled]="!canResendEmails()"
          (click)="undismiss(row.data)"
          andButton
          color="ghost"
          size="small"
        >
          Restore
        </button>
      </div>
    } @else if (isRetryable(row.data.reasonCode)) {
      <div
        tooltip="No actions available for this email."
        [tooltipEnabled]="isActionDisabled(row.data.status)"
      >
        <button
          #menuTrigger="matMenuTrigger"
          dataSelector="email-delivery-hub-failed-actions-button"
          type="button"
          [matMenuTriggerFor]="menu"
          [disabled]="isActionDisabled(row.data.status)"
          [isLoading]="isRowLoading(row.data.id)"
          andButton
          color="ghost"
          size="small"
          class="no-dropdown-arrow"
        >
          <anduin-icon name="more-horizontal" />
        </button>
      </div>

      <mat-menu #menu="matMenu">
        @if (menuTrigger.menuOpen) {
          <div
            tooltip="You do not have permissions to dismiss failed emails."
            [tooltipEnabled]="!canResendEmails()"
          >
            <button
              dataSelector="email-delivery-hub-failed-dismiss-button"
              [disabled]="!canResendEmails()"
              (click)="dismiss(row.data)"
              mat-menu-item
            >
              Dismiss
            </button>
          </div>

          <div
            tooltip="You do not have permissions to retry emails."
            [tooltipEnabled]="!canResendEmails()"
          >
            <button
              dataSelector="email-delivery-hub-failed-retry-button"
              [disabled]="!canResendEmails()"
              (click)="retry(row.data)"
              mat-menu-item
            >
              Retry
            </button>
          </div>
        }
      </mat-menu>
    } @else {
      <div
        [tooltip]="isActionDisabled(row.data.status) ? 'No actions available for this email.' : 'You do not have permissions to dismiss emails.'"
        [tooltipEnabled]="isActionDisabled(row.data.status) || !canResendEmails()"
      >
        <button
          dataSelector="email-delivery-hub-failed-dismiss-button"
          type="button"
          [disabled]="isActionDisabled(row.data.status) || !canResendEmails()"
          (click)="dismiss(row.data)"
          andButton
          color="ghost"
          size="small"
        >
          Dismiss
        </button>
      </div>
    }
  </div>
</ng-template>

<ng-template #reasonFilterLabel let-label>{{ label }}</ng-template>
